import React from 'react'
import { ThemeProvider } from 'styled-components'
import { theme } from 'wave-design-system-plus'

const Theme = ({ children }: any) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default Theme
